<template>
<span>
  <span class="badge send-to-info" v-for="msg in msgs">{{ msg }}</span>
</span>
</template>
<script>
export default {
  props: ['item'],
  computed: {
    msgs () {
      let a = []
      if (this.item.send_to_all) {
        a.push('Do wszystkich')
      } else {
        if (this.item.send_to_confirmed) {
          a.push('Do potwierdzonych')
        }
        if (this.item.send_to_notconfirmed) {
          a.push('Do niepotwierdzonych')
        }
        if (this.item.send_to_imported) {
          a.push('Do zaimportowanych')
        }
        if (this.item.send_to_signout) {
          a.push('Do wypisanych')
        }
      }
      return a
    }
  }
}
</script>


// WEBPACK FOOTER //
// SendTo.vue?811b0588